import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { FormlyFieldProps } from '@ngx-formly/primeng/form-field';
import { InputNumber } from 'primeng/inputnumber';
import { FORM_IMPORTS } from '../../_shared/_imports/form.import';

interface NumberFieldProps extends FormlyFieldProps {
  showButtons: boolean | null;
  buttonLayout?: 'vertical' | 'horizontal' | 'stacked' | null;
  inputId: string | null;
  decrementButtonClass?: string | null;
  incrementButtonClass?: string | null;
  incrementButtonIcon?: string | null;
  decrementButtonIcon?: string | null;
  step?: number;
  min?: number;
  max?: number;
  prefix?: string;
  suffix?: string;
  mode?: 'currency' | 'decimal';
  currency?: 'EUR' | 'USD' | string;
  minFractionDigits?: number;
  maxFractionDigits?: number;
  style?: any;
  disabled?: boolean;
  size?: 'small' | 'large';
  useGrouping?: boolean;
}

@Component({
  selector: 'number-field',
  standalone: true,
  imports: [...FORM_IMPORTS, InputNumber],
  template: `
    <p-inputNumber
      [formControl]="formControl"
      [formlyAttributes]="field"
      [style]="props.style"
      class="w-full"
      autocomplete="false"
      [showButtons]="props.showButtons ?? false"
      [buttonLayout]="props.buttonLayout ?? 'stacked'"
      [inputId]="props.inputId ?? 'horizontal'"
      [decrementButtonClass]="
        props.decrementButtonClass ?? 'p-button-secondary'
      "
      [incrementButtonClass]="
        props.incrementButtonClass ?? 'p-button-secondary'
      "
      [incrementButtonIcon]="props.incrementButtonIcon ?? 'fa-solid fa-plus'"
      [decrementButtonIcon]="props.decrementButtonIcon ?? 'fa-solid fa-minus'"
      [step]="props.step ?? 1"
      [min]="props.min ?? -10000000000000000000000"
      [max]="props.max ?? 10000000000000000000000"
      [prefix]="props.prefix ? props.prefix + ' ' : undefined"
      [suffix]="props.suffix ? ' ' + props.suffix : undefined"
      [mode]="props.mode ?? 'decimal'"
      [currency]="props.currency ?? undefined"
      [minFractionDigits]="props.minFractionDigits ?? null"
      [maxFractionDigits]="props.maxFractionDigits ?? null"
      locale="it-IT"
      [maxlength]="$any(props.maxLength)"
      [useGrouping]="props.useGrouping ?? false"
      [placeholder]="
        props.placeholder
          ? props.placeholder
          : props.suffix
            ? ' ' + props.suffix
            : undefined
      "
    />
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NumberFieldType extends FieldType<
  FieldTypeConfig<NumberFieldProps>
> {}
